import { Routes, Route } from 'react-router-dom'

import Layout from './components/Layout'
import Landing from './pages/Landing'
import Reference from './pages/Reference'
import AuthenticationGuide from './pages/guides/Authentication'
import ErrorsGuide from './pages/guides/Errors'
import RateLimitsGuide from './pages/guides/RateLimits'
import VersioningGuide from './pages/guides/Versioning'
import PublicEndpointsGuide from './pages/guides/PublicEndpoints'

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Landing />} />
        <Route path="/guides/authentication" element={<AuthenticationGuide />} />
        <Route path="/guides/errors" element={<ErrorsGuide />} />
        <Route path="/guides/rate-limits" element={<RateLimitsGuide />} />
        <Route path="/guides/versioning" element={<VersioningGuide />} />
        <Route path="/guides/public-endpoints" element={<PublicEndpointsGuide />} />
      </Route>
      {/* Reference page renders Scalar full-bleed, so it lives OUTSIDE the
          layout wrapper which has its own header/sidebar. */}
      <Route path="/reference" element={<Reference />} />
    </Routes>
  )
}
